<template>
  <div class="wrap">
    <Head />
    <div class="part1"> 
      <p class="p1">
        <span>持之以恒</span>
        <span>事在人为</span>
      </p>

    </div>
    <div class="part2">
      <p class="tit1">{{$t('m_aboutus.part2.tit')}}</p>
      <p class="desc">江苏恒为信息科技有限公司(以下称为“恒为信息科技”) 是全国区块链和分布式记账技术标准化技术委员会(SAC/TC590)委员单位、江苏省区块链标准化技术委员会(JS-TC63)委员单位，中国区块链技术和产业发展论坛理事单位、可信区块链推进计划会员单位、江苏省区块链发展协会副理事长单位、无锡市区块链产业联盟会长单位。</p>
      <p class="desc">恒为信息科技是由海归学子创建的一家专注于区块链底层技术研发及产业应用部署的江苏省高新技术企业，无锡市专精特新企业，公司于2015年成立于无锡高新区。恒为信息科技拥有完全自主知识产权的高性能区块链底层平台“恒为链”，相关区块链发明专利、软著等40多个，国家区块链信息服务备案项目19个、完成华为云服务、国产统信操作系统、国产申威处理器的信创适配。通过ISO、ITSS，知识产权贯标等多项国家认证。恒为信息科技还与大院大所及高校开展战略合作，内容包括区块链底层技研发及服务、区块链技术标准及测评，行业应用生态建设等。</p>
      <p class="desc">依托于独立自主研发的“城市链网”区块链底层基础设施建设技术，恒为信息科技在政务数据治理，数据共享；医疗物资管控，医疗数据共享；农产品溯源及金融服务，农村三资监管；国有资产监管、民政慈善捐款，社会救助；工业互联网，车联网；供应链管理，供应链金融；数字经济，金融监管等多个领域成功落地了30余个应用案例，拥有完整技术解决方案和产品。</p>
      <p class="desc">恒为信息科技发展至今成果斐然，参与编写了区块链国家标准1项和团体标准7项，牵头起草地方标准2项，参与编写国内首部《中国区块链与物联网融合创新应用蓝皮书》、《区块链应用操作员国家职业技术技能标准》，参与编写《区块链领导干部读本》、《江苏省工业区块链应用发展白皮书》、《无锡市政务区块链创新应用指南》、《江苏省区块链产业发展报告》、《江苏省工业区块链应用发展白皮书》、《无锡数字经济发展报告》等，2024年连续三年入选国家“产业区块链企业50强”，是无锡市区块链产业核心企业。</p>
    </div>
    <!-- 恒为信息 -->
    <div class="part3">
      <p class="tit1">{{$t('m_aboutus.part6.tit')}}</p>
      <p class="text1">{{$t('m_aboutus.part6.text1')}}</p>
      <p class="text2">{{$t('m_aboutus.part6.text2')}}</p>
    </div>
    <!-- 恒为大事件 -->
    <div class="part4">
      <p class="tit1">{{$t('m_aboutus.part5.tit')}}</p>
      <img
        src="../../assets/images/mobile/aboutus/part4.png"
        alt=""
      >
      <Timeline class="year">

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2015</span>
          <p class="data">2015</p>
          <p class="text texted">公司成立 </p>

        </TimelineItem>

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2016</span>
          <p class="data">2016</p>
          <p class="text texted">参加物博会</p>
        </TimelineItem>

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2017</span>
          <p class="data"> 5月12日</p>
          <p class="text">成立物联网+区块链联合实验室并发布行动计划</p>
          <p class="data">8月</p>
          <p class="text">发布《中国区块链与物联网融合创新应用蓝皮书》</p>
          <p class="data">12月22日</p>
          <p class="text">通过中国电子标准化研究院区块链系统技术测评</p>
          <p class="data">12月底</p>
          <p class="text texted">《中国区块链与物联网融合创新应用蓝皮书》的发布荣获“2017年度无锡市软件和信息服务业（企业）”十大最具影响力事件 </p>
        </TimelineItem>

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2018</span>
          <p class="data">9月17日</p>
          <p class="text texted">承办2018世界物联网大会区块链与物联网融合发展峰会 </p>
        </TimelineItem>

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2019</span>
          <p class="data">4月17日</p>
          <p class="text">启动国内首部物联网与区块链融合地方标准的编制 </p>
          <p class="data"> 8月
          <p>
          <p class="text">成为中国区块链技术和产业发展论坛理事成员</p>
          <p class="data">10月18日</p>
          <p class="text texted">“恒为链”成功通过境内区块链信息服务服务备案</p>
        </TimelineItem>

        <TimelineItem>
          <span
            slot="dot"
            class="time"
          >2020</span>
          <p class="data">4月13日</p>
          <p class="text">工信部发布《全国区块链和分布式记账技术标准化技术委员会委员名单》，恒为信息科技成为第一届委员成员</p>
          <p class="data">5月18日</p>
          <p class="text">成立恒为全资子公司“苏州恒链数科区块链科技有限公司”</p>
          <p class="data">6月9日</p>
          <p class="text">成立生态分公司“万物汇智信息技术（上海）有限公司”</p>
          <p class="data">6月23日</p>
          <p class="text texted">成立无锡市区块链产业联盟，恒为信息科技成为首届会长单位 </p>
        </TimelineItem>

      </Timeline>

    </div>
    <div class="part5">
      <p class="tit1">{{$t('m_aboutus.part3.tit')}}</p>
      <div class="swipe">
        <van-swipe
          indicator-color="white"
          :autoplay="3000"
        >
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-1.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-2.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-3.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-4.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-5.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-6.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-7.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-8.png"
                alt=""
              >
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="part6">
      <div class="card">
        <p class="tit">{{$t('m_aboutus.part4.tit')}}</p>
        <div class="row">
          <div class="left">
            <i class="iconfont icondianhua"></i>
          </div>
          <div class="right">固定电话：0510-85386599</div>
        </div>

        <div class="row">
          <div class="left">
            <i class="iconfont iconxinfeng"></i>
          </div>
          <div class="right">
            <p>技术合作：service@hwelltech.com</p>
            <p>商务洽谈：marketing@hwelltech.com</p>
            <p>战略部署：blockchain@hwelltech.com</p>
          </div>
        </div>

        <div class="row end">
          <div class="left">
            <i class="iconfont icondingwei"></i>
          </div>
          <div class="right">地址：无锡市新吴区菱湖大道111号天鹅座D栋19层</div>
        </div>

        <div class="erweima">
          <img
            src="../../assets/images/mobile/aboutus/erweima.png"
            alt
          />
          <p class="des">扫一扫二维码 关注我们</p>
        </div>
      </div>
      <div class="ditu">
        <img
          src="../../assets/images/mobile/aboutus/ditu.png"
          alt
        />
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import { Timeline, TimelineItem } from "iview";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      isCN: true,
    };
  },
  components: {
    Head,
    Foot,
    Timeline,
    TimelineItem,
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      //   this.isCN=localStorage.getItem('Lang')=='cn'?true:false;
      this.isCN = this.$i18n.locale == "cn" ? true : false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  width: vw(750);
  bg(url('../../assets/images/mobile/aboutus/bg.png'));
  overflow: hidden;
  margin-top: vw(98);

  .p1 {
    font-size: vw(40);
    color: rgba(221, 242, 255, 1);
    line-height: vw(40);
    margin-top: vw(80);
    text-align: center;

    span:nth-child(1) {
      display: inline-block;
      margin-right: vw(15);
    }

    span:nth-child(2) {
    }
  }
}

.part2 {
  part();
  padding: vw(80) 0 vw(50);

  .tit1 {
    tit3();
    margin-bottom: vw(32);
  }

  .desc {
    padding: 0 vw(35);
    font-size: vw(28);
    color: #666;
    line-height: vw(48);
    text-indent: 2em;
    margin-bottom: vw(30);
  }
}

.part3 {
  part();
  bg: url('../../assets/images/mobile/aboutus/part3.png');
  padding: vw(80) 0 vw(50);

  .tit1 {
    tit3();
    color: #fff;
    margin-bottom: vw(40);
  }

  .text1, .text2 {
    padding: 0 vw(39);
    font-size: vw(28);
    color: #fff;
    line-height: vw(40);
    margin-bottom: vw(30);
    text-indent: 2em;
  }
}

.part4 {
  part();
  background: rgba(249, 249, 249, 1);
  position: relative;

  .tit1 {
    tit3();
    margin-bottom: vw(40);
    color: rgba(68, 68, 68, 1);
  }

  img {
    width: 100%;
    position: absolute;
    top: vw(303);
  }

  .year {
    padding: 0 vw(35);

    /deep/.ivu-timeline-item-head {
      background-color: rgba(249, 249, 249, 1);
    }

    .time { // 标签
      display: inline-block;
      // vertical-align: top;
      width: vw(65);
      height: vw(65);
      color: rgba(42, 147, 255, 1);
      border-radius: 50%;
      background: #fff;
      text-align: center;
      border: none;
      box-shadow: 0 0 0 vw(2) rgba(42, 147, 255, 1);
      font-size: vw(24);
      line-height: vw(65);
    }

    /deep/.ivu-timeline-item-content {
      padding: vw(92) 0 vw(10) vw(40);
    }
  }

  /deep/.ivu-timeline-item-tail {
    top: vw(45);
    border-left: vw(2) solid rgba(218, 218, 218, 1);
  }

  .data {
    font-size: vw(24);
    line-height: vw(24);
    color: rgba(153, 153, 153, 1);
    margin-bottom: vw(12);
  }

  .text {
    font-size: vw(28);
    color: rgba(68, 68, 68, 1);
    line-height: vw(36);
    margin-bottom: vw(36);
  }

  .texted {
    margin-bottom: 0;
  }
}

.part5 {
  part();
  background-color: #fff;

  .tit1 {
    tit3();
    margin-bottom: vw(70);
  }

  .card {
    width: vw(629);
    height: vw(877);
    margin: 0 auto vw(50);

    img {
      width: 100%;
      height: auto;
    }

    .top {
      margin-top: vw(214);
    }
  }

  .swipe {
    /deep/.van-swipe { // 滑动底部导航
      .van-swipe__indicators {
        .van-swipe__indicator {
          width: vw(16);
          height: vw(16);
          background-color: transparent;
          border: 1px solid #2A93FF;
          opacity: 1;
        }

        .van-swipe__indicator--active {
          background: #2A93FF !important;
        }
      }
    }
  }
}

.part6 {
  part();
  background: rgba(249, 249, 249, 1);
  padding-bottom: 0;

  .card {
    margin: 0 vw(30);
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    padding: vw(40) vw(30);

    .tit {
      font-size: vw(32);
      line-height: vw(32);
      color: #333;
      margin-bottom: vw(28);
    }

    .row {
      display: flex;
      min-height: vw(40);

      .left {
        line-height: vw(48);
        width: vw(26);
        margin-right: vw(20);
        text-align: center;

        i {
          color: rgba(42, 147, 255, 1);
        }
      }

      .right {
        line-height: vw(48);
        flex: 1;
        font-size: vw(28);
        color: rgba(68, 68, 68, 1);
      }
    }

    .end {
      margin-bottom: vw(35);
    }

    .erweima {
      width: 100%;
      display: flex;
      padding-top: vw(40);
      border-top: 1px solid rgba(198, 198, 198, 1);

      img {
        width: vw(140);
        height: vw(140);
      }

      .des {
        flex: 1;
        font-size: vw(28);
        line-height: vw(28);
        color: rgba(68, 69, 76, 1);
        margin: vw(55) 0 0 vw(30);
        vertical-align: top;
      }
    }
  }

  .ditu {
    width: vw(750);
    height: vw(522);
    margin-top: vw(28);

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
